module.exports = __webpack_public_path__ + "static/media/4p_room.b57b3a14.svg";